<template>
  <component :is="tag"
    class="zord-card"
    :class="{
      'zord-card--interactive': isInteractive || hasTrailingIcon,
      'zord-card--primary':isPrimary,
      'zord-card--padded': isPadded
    }"
    :role="isInteractive && tag !== 'a' ? 'button' : null"
  >
    <div class="zord-card-content">
      <slot />
    </div>

    <div class="zord-card-trailing-icon" v-if="hasTrailingIcon">
      <slot name="trailingIcon" />
    </div>
  </component>
</template>

<script>
export default {
  name: 'ZordCard',
  data() {
    return {
      tag: 'div'
    }
  },
  props: {
    isInteractive: {
      type: Boolean,
      default: false,
    },
    isPrimary: {
      type: Boolean,
      default: false
    },
    isPadded: {
      type: Boolean,
      default: false
    },
    hasTrailingIcon: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.tag = this.$attrs.href ? 'a' : 'div'
  }
}
</script>

<style lang="scss" scoped>
  .zord-card {
    padding: var(--box-spacing);
    color: var(--text-color);
    font-size: var(--text-size);
    background-color: var(--white);
    box-shadow: var(--default-box-shadow);
    border-radius: var(--border-radius);

    &--interactive {
      display: flex;
      align-items: center;
      border: var(--default-border);
      border-radius: var(--border-radius-l);
      box-shadow: none;
      text-decoration: none;
      cursor: pointer;

      &:hover,
      &:focus
      &:active {
        border-color: var(--primary-color);
      }
    }

    &--primary {
      background-color: var(--card-primary-color);
      border-color: var(--card-primary-color);
      border-radius: 0;

      &:hover,
      &:focus,
      &:active {
        border-color: var(--card-primary-color);
      }
    }

    &--padded {
      padding: var(--box-spacing-l);
    }

    &-trailing-icon {
      margin-left: auto;
    }
  }
</style>
